import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'

export type TagTone = 'neutral' | 'accent' | 'ok' | 'warn' | 'bad'

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: TagTone
  children: ReactNode
}

/**
 * A fact you read — "Free", "Last days", "Sold out". Not a control: it has no
 * press, no hit area and no hover, which is the line between this and `Chip`.
 * 4px radius so it never reads as a button, caption size at 600, sentence case
 * (D3 removed the tracked-uppercase style and this is not a way back to it).
 */
export const Tag = forwardRef<HTMLSpanElement, TagProps>(function Tag(
  { tone = 'neutral', className = '', children, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={`u-tag u-tag--${tone} ${className}`.trim()} {...rest}>
      {children}
    </span>
  )
})
